import { IonButton, IonContent, IonHeader, IonInput, IonItem, IonItemGroup, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle } from "@ionic/react";
import { useState } from "react";
import { Redirect } from "react-router";
import { Spacing } from "../components/spacing";
import { useAuth } from "../hooks/auth";

const LoginPage: React.FC = () => {
  const auth = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const login = async () => {
    await auth.login(username, password);
  };

  if (auth.authenticated) return <Redirect to="/" />;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Welcome to a Better VULMS</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <main style={{ height: "100%", display: "grid", placeItems: "center" }}>
          <IonCard style={{ padding: "1rem" }}>
            <IonCardHeader>
              <IonCardTitle>Login</IonCardTitle>
              <IonCardSubtitle>
                Login with your VULMS credentials, <a href="#todo">is this secure?</a>
              </IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <IonItemGroup>
                <IonItem>
                  <IonLabel>Username</IonLabel>
                  <IonInput name="username" value={username} onIonChange={(e) => setUsername(e.detail.value!)}></IonInput>
                </IonItem>
                <IonItem>
                  <IonLabel>Password</IonLabel>
                  <IonInput name="password" value={password} onIonChange={(e) => setPassword(e.detail.value!)} type="password"></IonInput>
                </IonItem>
              </IonItemGroup>

              <Spacing />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <IonButton onClick={login}>Login</IonButton>
              </div>
            </IonCardContent>
          </IonCard>
        </main>
      </IonContent>
    </IonPage>
  );
};

export default LoginPage;
